<template>
  <div class="news-labels">
    <span :class="`badge badge-pill news-category news-category-${item.category}`">
      {{ $t(`news.categories.${item.category}`) }}
    </span>
    <span class="news-topic-label">
      {{ $t(`news.topics.${item.topic}`) }}
    </span>
    <span class="news-date">
      {{ date }}
    </span>
    <i
      v-if="item.pinned"
      class="far fa-thumbtack news-date"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    longDate: Boolean,
  },
  computed: {
    date() {
      const m = moment(this.item.timestamp);
      if (this.longDate) {
        return m.format('D MMMM YYYY');
      }
      return moment().diff(m, 'days') < 2 ? m.fromNow() : m.format('D MMM');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/vars';

.news-labels {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.news-category {
  font-size: 11px;
  color: #fff;
}

.news-category-New { background: $blue; }
.news-category-Improvement { background: $green; }
.news-category-Change { background: $orange; color: #212529; }
.news-category-Important { background: $red; }

.news-topic-label {
  padding: 0 7px;
  border-radius: 6px;
  border: 1px solid #cfd4da;
  color: #495057;
  font-size: 11px;
  font-weight: 500;
}

.news-date {
  font-size: 12px;
  color: #999;
}
</style>
